exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-card-text[data-v-2f209f3a] p:last-child {\n  margin-bottom: 0;\n}\n", ""]);

